// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".faq-list__groups[data-v-64c5c584]{overflow:hidden}.faq-list__groups .tdx-scroll-navigation[data-v-64c5c584]{padding-bottom:.3125rem}.faq-list .items[data-v-64c5c584]{overflow:hidden}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
